import { RastreioCancerPerguntaDbEnum, RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

export type SolicitacaoExameCitopatologicoQueryModel = {
  id: ID
  questoes: ReadonlyArray<{
    id: ID
    pergunta: RastreioCancerPerguntaDbEnum
    resposta: string
  } | null>
}

export const CITOPATOLOGICO_PERGUNTAS_ANAMNESE: Partial<Record<RastreioCancerPerguntaDbEnum, string>> = {
  PERGUNTA_CITO_01_01: 'Motivo do Exame',
  PERGUNTA_CITO_01_02: 'Situação especial',
  PERGUNTA_CITO_01_03: 'Fez exame preventivo anteriormente?',
  PERGUNTA_CITO_01_04: 'Mês e ano em que realizou o último preventivo',
  PERGUNTA_CITO_01_05: 'Usa DIU?',
  PERGUNTA_CITO_01_06: 'Está grávida?',
  PERGUNTA_CITO_01_07: 'Usa pílula anticoncepcional?',
  PERGUNTA_CITO_01_08: 'Usa hormônio / remédio para tratar a menopausa?',
  PERGUNTA_CITO_01_09: 'Já fez tratamento de radioterapia?',
  PERGUNTA_CITO_01_10: 'Data da última menstruação',
  PERGUNTA_CITO_01_11: 'Tem ou teve sangramento após relação sexual?',
  PERGUNTA_CITO_01_12:
    'Tem ou teve algum sangramento após a menopausa? (não considerar o(s) sangramento(s) na vigência de reposição hormonal)',
}

export const CITOPATOLOGICO_PERGUNTAS_EXAME_CLINICO: Partial<Record<RastreioCancerPerguntaDbEnum, string>> = {
  PERGUNTA_CITO_02_01: 'Inspeção do colo',
  PERGUNTA_CITO_02_02: 'Sinais sugestivos de IST',
}

export const CITOPATOLOGICO_PERGUNTAS_DADOS_COLETA: Partial<Record<RastreioCancerPerguntaDbEnum, string>> = {
  PERGUNTA_CITO_03_01: 'Data da coleta',
  PERGUNTA_CITO_03_02: 'Nome:',
  PERGUNTA_CITO_03_03: 'CNS:',
  PERGUNTA_CITO_03_04: 'Número:',
  PERGUNTA_CITO_03_05: 'Nome:',
}

export enum MotivoExame {
  RASTREAMENTO = 'RASTREAMENTO',
  REPETICAO = 'REPETICAO',
  SEGUIMENTO = 'SEGUIMENTO',
}

export enum SituacaoEspecial {
  PESSOA_HIV = 'PESSOA_HIV',
  OUTRAS_SITUACOES = 'OUTRAS_SITUACOES',
  NUNCA_FEZ_PREVENTIVO = 'NUNCA_FEZ_PREVENTIVO',
}

export const CitopatologicoPerguntaField = {
  motivoExame: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_01,
  situacaoEspecial: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_02,
  examePreventivo: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_03,
  dataPreventivo: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_04,
  diu: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_05,
  estaGravida: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_06,
  usaPilulaAnticoncepcional: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_07,
  usaHormonio: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_08,
  radioterapia: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_09,
  dum: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_10,
  sangramentoPosRelacao: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_11,
  sangramentoPosMenopausa: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_12,
  inspecaoColo: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_02_01,
  sinaisSugestivosDeIst: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_02_02,
  dataDaColeta: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_01,
  nomeResponsavel: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_02,
  cns: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_03,
  numeroConselho: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_04,
  siglaNomeConselho: RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_03_05,
} as const

type PerguntaFields = typeof CitopatologicoPerguntaField[keyof typeof CitopatologicoPerguntaField]

export type RequisicaoExameCitopatologicoFormValues = Partial<
  Record<PerguntaFields, RastreioCancerPerguntaOpcaoEnum | string>
> & {
  checkDum?: boolean
}
